<template>
  <div>
    <el-dialog
      :visible.sync="show"
      :before-close="handleClose"
      custom-class="custom-class"
      class="easyplayer-class"
      :show-close="false"
    >
      <img
        class="guanbi"
        :src="require('@/assets/image/wind/kuang4_icon.png')"
        alt=""
        srcset=""
        @click="handleClose"
      />
      <div class="easyplayer-body">
        <div class="title">
          {{
            listBoole
              ? showData[index - 1]
                ? showData[index - 1].title
                : ""
              : showData
              ? showData.title
              : ""
          }}
        </div>
        <div class="video">
          <easy-player
            :video-url="
              listBoole
                ? showData[index - 1]
                  ? showData[index - 1].url
                  : ''
                : showData
                ? showData.url
                : ''
            "
            :loop="true"
            :live="true"
            :has-audio="false"
            class="easyplayer"
          ></easy-player>
        </div>
        <div
          class="left cursorPointer"
          v-if="listBoole"
          @click="turnPageClick(true)"
        >
          {{ "<" }}
        </div>
        <div
          class="right cursorPointer"
          v-if="listBoole"
          @click="turnPageClick(false)"
        >
          {{ ">" }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showData: {
      type: [Object, Array],
      default: null,
    },
    listBoole: {
      type: Boolean,
      default: false,
    },
    listIndex: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    listIndex: {
      immediate: true,
      handler(newValue, oldValue) {
        this.index = newValue;
        console.log("x");
      },
    },
    show: {
      immediate: true,
      handler(newValue, oldValue) {
        this.index = this.listIndex;
      },
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    handleClose() {
      this.$emit("handleClose", false);
    },
    turnPageClick(boole) {
      if (boole) {
        this.index--;
      } else {
        this.index++;
      }
      if (this.index > this.showData.length) {
        this.index = this.showData.length;
      } else if (this.index < 1) {
        this.index = 1;
      }
    },
  },
};
</script>
<style lang="scss">
.easyplayer-class {
  z-index: 9999 !important;
  height: 100%;
  .el-dialog {
    margin: 0px !important;
    top: calc(50% - 350px) !important;
    left: calc(50% - 550px);
    height: 720px;
    width: 1100px;
    position: absolute;
    background-image: url("@/assets/image/wind/kuang4.png") !important;
    background-size: 100% 100%;
    background-color: #0000 !important;
    padding: 50px 70px !important;
  }
  .el-dialog__body {
    padding: 0px !important;
    height: 100%;
  }
  .el-dialog__header {
    height: 0px;
    padding: 0px;
  }
  .guanbi {
    position: absolute;
    top: 50px;
    right: 50px;
    width: 40px;
    height: 35px;
  }
  .easyplayer-body {
    height: 100%;
    width: 100%;
    .title {
      width: 100%;
      height: 70px;
      line-height: 70px;
      text-align: center;
      font-size: 50px;
      color: white;
    }
    .video {
      //   height: calc(100% - 70px);
      width: 100%;
      height: 540px;
    }
    .left,
    .right {
      position: absolute;
      top: calc(50% - 20px + 70px);
      height: 40px;
      width: 40px;
      background-color: rgba($color: #aaa, $alpha: 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      color: rgba($color: #fff, $alpha: 0.8);
      border-radius: 50%;
    }
    .left:hover,
    .right:hover {
      background-color: rgba($color: #aaa, $alpha: 0.5);
    }
    .left {
      left: 80px;
    }
    .right {
      right: 80px;
    }
  }
}
</style>
